import {
  ATTEMPT_STATUSES,
  HEIGHT_OF_ONE_HOUR,
  SNAP_INTERVAL_IN_HOURS,
  USER_COLORS,
} from "@miplatform/constants";
import {
  getDateWithAddedTime,
  getDurationInHours,
  snapAdjusted,
  toHour,
} from "@miplatform/utils";

export const useMapViewModel = () => {
  let colorIndex = 0;

  const getUserColor = () => {
    const color = USER_COLORS[colorIndex];
    colorIndex = (colorIndex + 1) % USER_COLORS.length;
    return color;
  };

  const adjustEventTimes = (events) =>
    events.map((e) => ({
      ...e,
      y:
        snapAdjusted(
          toHour(e.startDate || e.scheduledStartDate),
          SNAP_INTERVAL_IN_HOURS
        ) * HEIGHT_OF_ONE_HOUR,
      duration: getDurationInHours(
        e.startDate || e.scheduledStartDate,
        (e.attemptStatus === ATTEMPT_STATUSES.SUBMITTED && e.endDate) ||
          e.scheduledEndDate ||
          getDateWithAddedTime(e.scheduledStartDate, {
            m: e.expectedDuration,
          })
      ),
    }));

  const getUserData = ({ data = [], groupBy, users = [] }) => {
    const userData = users.reduce((acc, user) => {
      const item = { ...user };
      item.color = getUserColor();
      const events = data.filter(
        (event) =>
          event[groupBy] === item[groupBy] || event[groupBy] === item.id
      );
      events.sort(
        (a, b) => toHour(a.scheduledStartDate) - toHour(b.scheduledStartDate)
      );
      acc.set(item, adjustEventTimes(events));
      return acc;
    }, new Map());

    return Array.from(userData.entries());
  };

  return { getUserData };
};
